module.exports = __webpack_public_path__ + "img/climate_actions_partner@2x.96a3725.webp";